import ControlTower from "wise-control-tower";

/**
 * Called by ember-intl when a translation is missing (see `routes/application.ts`).
 * The returned message is displayed instead of the translation.
 * [ember-intl doc](https://ember-intl.github.io/ember-intl/docs/services/intl-part-2#methods-set-on-missing-translation)
 * @param {string} key
 * @param {string[]} locales
 * @returns string
 */
export default function missingMessage(key, locales) {
  const message = `Missing translation "${key}" for locales "${locales}"`;
  ControlTower.captureException(new Error(`[ember-intl] ${message}`));
  return message;
}
